/** Stacking order for node/edge contextual toolbars inside the React Flow viewport. */
export const CANVAS_FLOATING_TOOLBAR_Z_INDEX = 1000;
